import axios from "axios";
import Swal from "sweetalert2";

export const getProducts = async (filters, currentPage) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const selectedStoreId = localStorage.getItem("selectedStore");
    const storeId = selectedStoreId?.id ? selectedStoreId?.id : null;
    const { data } = await axios.get("/v1/admin/products", {
      params: {
        ...filters,

        page: currentPage,
      },

      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
        "store-id": storeId,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const showProducts = async (id, selectedLangCode) => {
  try {
    const brear = localStorage.getItem("token");
    let lang = localStorage.getItem("i18nextLng");
    if (selectedLangCode) {
      lang = selectedLangCode;
    }
    const { data } = await axios.get(`/v1/admin/products/${id}`, {
      params: {
        lang: lang,
      },
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        "Accept-Language": lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const storeProduct = async (postData) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.post("/v1/admin/products", postData, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const editProduct = async (postData, id) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.post(`/v1/admin/products/${id}`, postData, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteProduct = async (id, lang) => {
  const brear = localStorage.getItem("token");
  const result = await Swal.fire({
    title: "هل انت متأكد ؟",
    text: "سيتم الحذف",
    icon: "warning",
    showCancelButton: true,
    cancelButtonColor: "#d33",
    confirmButtonText: "Okay",
  });
  if (result.isConfirmed) {
    try {
      const { data } = await axios.delete(`v1/admin/products/${id}`, {
        headers: {
          Authorization: "Bearer " + `${brear}`,
          app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
          lang: lang,
        },
      });
      if (data.success === true) {
        Swal.fire("Deleted!", `${data.message}`, "success");
      } else {
        Swal.fire("Not deleted", `${data.message}`, "info");
      }
      return data;
    } catch (error) {
      throw error;
    }
  }
};

export const importExcelProduct = async (file) => {
  try {
    const bearer = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");

    const formData = new FormData();
    formData.append("file", file);

    const { data } = await axios.post("/v1/admin/products-import", formData, {
      headers: {
        Authorization: `Bearer ${bearer}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang,
        "Content-Type": "multipart/form-data",
      },
    });

    return data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const exportExcelProducts = async () => {
  try {
    const bearer = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");

    const response = await axios.get(
      "/v1/admin/products-export",

      {
        headers: {
          Authorization: `Bearer ${bearer}`,
          app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
          lang,
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
